module.exports = __webpack_public_path__ + "assets/facialExpression.ae47d311.svg";